import { useState } from "react";
import { Blueprint, BlueprintConfigurationError } from "../../../../models/Blueprints";

interface BlueprintConfigurationErrorState {
  blueprint: Blueprint;
  error: BlueprintConfigurationError | undefined;
}

const useBlueprintConfigurationError = (
  blueprint: Blueprint
): [
  BlueprintConfigurationError | undefined,
  (error: BlueprintConfigurationError | undefined) => void
] => {
  const [state, setState] = useState<BlueprintConfigurationErrorState>();

  const error = state?.blueprint === blueprint ? state.error : undefined;
  const setError = (nextError: BlueprintConfigurationError | undefined) => {
    setState({ blueprint, error: nextError });
  };

  return [error, setError];
};

export default useBlueprintConfigurationError;
